import { render, staticRenderFns } from "./changelogEdit.vue?vue&type=template&id=4e594bf6&scoped=true"
import script from "./changelogEdit.vue?vue&type=script&lang=js"
export * from "./changelogEdit.vue?vue&type=script&lang=js"
import style0 from "./changelogEdit.vue?vue&type=style&index=0&id=4e594bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e594bf6",
  null
  
)

export default component.exports